import { ReactNode } from 'react';
import styled from 'styled-components';

import FormInputHelp from '#/components/Form/FormInputHelp';
import { remify } from '#/service/utils';

import { PaymentFormKey } from './components';

// CVV help for the payment UI

const CvvHelpGrid = styled.div`
  display: grid;
  grid-template-areas:
    'text text'
    'img1 img2';
  gap: ${remify(16)};
  width: min-content;
  text-align: center;
`;

CvvHelpGrid.displayName = 'CvvHelpGrid';

const CvvHelpText = styled.div`
  margin-bottom: ${remify(16)};
  grid-area: text;
`;

CvvHelpText.displayName = 'CvvHelpText';

const CvvHelpImage = styled.img`
  width: ${remify(136)};
`;

CvvHelpImage.displayName = 'CvvHelpImage';

interface CvvHelpProps {
  children?: ReactNode;
}

const CvvHelp = ({ children }: CvvHelpProps) => (
  <FormInputHelp dataKey={PaymentFormKey.SecurityCode}>
    <CvvHelpGrid>
      <CvvHelpText>{children}</CvvHelpText>
      <CvvHelpImage src="https://one-client-web-dev.s3.eu-north-1.amazonaws.com/images/cvv-help-1.png" />
      <CvvHelpImage src="https://one-client-web-dev.s3.eu-north-1.amazonaws.com/images/cvv-help-2.png" />
    </CvvHelpGrid>
  </FormInputHelp>
);

CvvHelp.displayName = 'CvvHelp';

export default CvvHelp;
